export default ({allClients}) => allClients.data;
